import React, { useEffect } from "react";
import navUrls from "../navigationURLS.json";
import PropTypes from "prop-types";
import { gtmFunction } from './gtm';
import './footer.css';

const Footer = ({ ariaLabelChange, controledTemplate = false }) => {
  useEffect(() => {
    document.querySelectorAll('.links-body ul > li > a').forEach((item) => {
      item.addEventListener('click', event => gtmFunction(event.target.href, event.target.innerText), { once: true });
    });
  });
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-links">
          <div className="row">
            <div className="col">
              <div className="logo">
                <svg className="footer-logo" width="55" height="55" aria-labelledby="HomeServeLogo" focusable="false" data-name="Loading Wording" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55">
                  <title id="HomeServeLogo">Logo</title>
                  <path fill="#e7342c" className="house" d="M52.76,26c-2.87-2.87-23-22.31-23-22.31a2.89,2.89,0,0,0-4.08,0L17,12.1V10.89A2.89,2.89,0,0,0,14.11,8H10.89A2.89,2.89,0,0,0,8,10.89V21L2.78,26.1a2.86,2.86,0,0,0-.84,2.22A3,3,0,0,0,5,31H8V50.11A2.89,2.89,0,0,0,10.9,53H45.1A2.88,2.88,0,0,0,48,50.15L48,31h3.29a2.72,2.72,0,0,0,2.89-2.89C54.2,27,53.21,26.44,52.76,26Z"></path>
                  <path fill="#444" className="smile" d="M43.93,39.73a20.4,20.4,0,0,1-15.86,7.33A20.39,20.39,0,0,1,12.19,39.7a1.7,1.7,0,1,1,2.66-2.12,16.92,16.92,0,0,0,13.22,6.08,16.92,16.92,0,0,0,13.2-6.05,1.7,1.7,0,1,1,2.66,2.13"></path>
                </svg>
              </div>
            </div>
          </div>
          <CollapsableMenu navUrls={navUrls} ariaLabelChange={ariaLabelChange} />
          <div className="row">
            <div className="inline-links links-body">
              <ul>
                <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Privacy Policy']}`} role="link" title="Privacy Policy">Privacy Policy</a></li>
                <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Cookies Policy']}`} role="link" title="Cookies Policy">Cookies Policy</a></li>
                <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Terms of Use']}`} role="link" title="Terms of Use">Terms of Use</a></li>
                <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Anti-Slavery Statement']}`} role="link" title="Modern Slavery Statement">Modern Slavery Statement</a></li>
                <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Gender Pay Information HomeServe']}`} role="link" title="Gender Pay Information">Gender Pay Information</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="red-line"></div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="footer-base-content left">
              <span>&copy;{` HomeServe Membership Limited ${new Date().getFullYear()}.`}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-baseline">
        <div className="container">
          <div className="row">
            <div className="col">
              <p>{controledTemplate === true ? `HomeServe is a trading name of HomeServe Membership Limited. Authorised and regulated by the Financial Conduct Authority for its general insurance activities. Ding is a trading name of HomeServe Membership Limited. Registered in England and Wales, number 2770612. Registered office: Cable Drive, Walsall, WS2 7BN. VAT registration number GB 559669669.` : `HomeServe is a trading name of HomeServe Membership Limited. Authorised and regulated by the Financial Conduct Authority for its general insurance activities. Registered in England and Wales, number 2770612. Registered office: Cable Drive, Walsall, WS2 7BN. VAT registration number GB 559669669.`}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
};

const CollapsableMenu = ({ navUrls, ariaLabelChange = false }) => {
  const [collapseSection, setCollapseSection] = React.useState({ 1: true, 2: true, 3: true });

  const handleCollapse = (secId) => {
    const section = { ...collapseSection };
    section[secId] = !section[secId];
    setCollapseSection(section);
  }

  const handleCollapseByKey = (event, secId) => {
    // For enter & space key
    if (event.key === 'Enter' || event.key === ' ') {
      const section = { ...collapseSection };
      section[secId] = !section[secId];
      setCollapseSection(section);
    }
  }

  return (
    <div className="row footer-collapsable-menu">
      <div className="col">
        <div className="links-col">
          <div className="links-header" onClick={() => handleCollapse(1)} onKeyDown={(event) => handleCollapseByKey(event, 1)}>
            <label tabIndex="0">Products and Services</label> <i aria-hidden="true" className={(collapseSection[1]) ? 'icon-hs-chevron-down' : 'icon-hs-chevron-up'}></i>
          </div>
          <div className="links-body">
            <ul className={(collapseSection[1]) ? 'collapse-menu' : null}>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Products and services']}`} role="link" title="What we do">What we do</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Plumbing and drainage cover']}`} role="link" title="Plumbing and Drainage Cover">Plumbing and Drainage Cover</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Boiler cover']}`} role="link" title="Gas Boiler and Heating Cover">Gas Boiler and Heating Cover</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Landlord boiler and plumbing cover']}`} role="link" title="Landlord Cover">Landlord Cover</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Boiler install']}`} rel="noopener noreferrer" role="link" title="New Boilers" aria-label="New Boilers">New Boilers</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="links-col">
          <div className="links-header" onClick={() => handleCollapse(2)} onKeyDown={(event) => handleCollapseByKey(event, 2)}>
            <label tabIndex="0">About Us</label> <i aria-hidden="true" className={(collapseSection[2]) ? 'icon-hs-chevron-down' : 'icon-hs-chevron-up'}></i>
          </div>
          <div className="links-body">
            <ul className={(collapseSection[2]) ? 'collapse-menu' : null}>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Why trust HomeServe']}`} role="link" title="About HomeServe">About HomeServe</a></li>
              <li><a href="https://www.homeservejobs.co.uk" role="link" title="Careers at HomeServe">Careers at HomeServe</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Become a Tradesperson']}`} role="link" title="Become a Tradesperson">Become a Tradesperson</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Media Centre']}`} role="link" title="Media Centre">Media Centre</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="links-col">
          <div className="links-header" onClick={() => handleCollapse(3)} onKeyDown={(event) => handleCollapseByKey(event, 3)}>
            <label tabIndex="0">More from HomeServe</label> <i aria-hidden="true" className={(collapseSection[3]) ? 'icon-hs-chevron-down' : 'icon-hs-chevron-up'}></i>
          </div>
          <div className="links-body">
            <ul className={(collapseSection[3]) ? 'collapse-menu' : null}>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Refer_a_Friend']}`} role="link" title="Refer a friend">Refer a friend</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['FAQ']}`} role="link" title="Frequently Asked Questions">Frequently Asked Questions</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['HomeServe Living']}`} role="link" title="Knowledge Hub">Knowledge Hub</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Contact us']}`} role="link" title="Contact Us">Contact Us</a></li>
              <li><a href={`${process.env.GATSBY_BASE_URL}/${navUrls['Accessibility']}`} role="link" title="Accessibility">Accessibility</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="links-col">
          <div className="social-icons">
            <ul>
              <li>
                <a href="https://www.facebook.com/HomeServeUK" rel="noopener noreferrer" target="_blank" aria-label={ariaLabelChange ? "HomeServe on Facebook" : "HomeServe on Facebook (opens in a new tab)"} title="Visit HomeServe on Facebook?" tabIndex="0">
                  <i aria-hidden="true" className="icon-hs-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://www.twitter.com/HomeServeUK" rel="noopener noreferrer" target="_blank" role="link" aria-label={ariaLabelChange ? "HomeServe on Twitter" : "HomeServe on Twitter (opens in a new tab)"} title="Visit HomeServe on Twitter?" tabIndex="0">
                  <i aria-hidden="true" className="icon-hs-twitter"></i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/user/homeserve" rel="noopener noreferrer" target="_blank" role="link" aria-label={ariaLabelChange ? "HomeServe on YouTube" : "HomeServe on YouTube (opens in a new tab)"} title="Visit HomeServe on YouTube?" tabIndex="0">
                  <i aria-hidden="true" className="icon-hs-youtube"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/homeserve_uk" rel="noopener noreferrer" target="_blank" role="link" aria-label={ariaLabelChange ? "HomeServe on Instagram" : "HomeServe on Instagram (opens in a new tab)"} title="Visit HomeServe on Instagram?" tabIndex="0">
                  <i aria-hidden="true" className="icon-hs-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/homeserve" rel="noopener noreferrer" target="_blank" role="link" aria-label={ariaLabelChange ? "HomeServe on LinkedIn" : "HomeServe on LinkedIn (opens in a new tab)"} title="Visit HomeServe on LinkedIn?" tabIndex="0">
                  <i aria-hidden="true" className="icon-hs-linked-in"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer;
Footer.propTypes = {
  ariaLabelChange: PropTypes.bool,
  controledTemplate: PropTypes.bool
};